module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3ubCLf/images/cover.jpg?1684514748986",
      "alt": "This image is the cover for the book The Courage to Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Courage to Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Between Love and Honor")])])]), _c('p', [_vm._v("In 1915, after his beloved Carl died from a vicious beating, David Harrison enlisted in the Army and went to war. He returns home to find a world seemingly unchanged, while he will never be the same. At Mrs. Gill’s boarding house, he meets Bernard Donnelly, a young man suffering the aftereffects of his own war experiences. David finds himself increasingly attracted to Bernard, but that terrifies him. He blames himself for Carl’s horrific death and fears he isn’t strong enough to lose another love to violence.")]), _vm._v(" "), _c('p', [_vm._v("Bernard needs David to help him face each day and find a way they can be together without stigma—and without putting them in legal and physical danger—but David clings to his idea that the only way to keep a lover safe is not to have one. His fears threaten to destroy everything, unless he learns that sometimes the risk is worth it and finds the courage to love.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      E E Montgomery\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0